module.exports = __webpack_public_path__ + "img/car-icon-transparent-black.72ac8753.svg";